import { Fixtuur } from '@fixtuur/backpack';
import * as O from 'fp-ts/Option';
import { pipe } from 'fp-ts/lib/function';
var getStatus = function (currentGood, productSelectionsByPart, partName, incompatibleIds) {
    if (incompatibleIds === void 0) { incompatibleIds = []; }
    if (!productSelectionsByPart)
        return 'none';
    return pipe(Fixtuur.Good.id(currentGood), O.map(function (id) {
        return incompatibleIds.includes(id)
            ? 'incompatible'
            : Fixtuur.Configuration.ProductSelectionsByPart.includes(productSelectionsByPart, partName, id)
                ? 'selected'
                : 'none';
    }), 
    /**
     * A Good has no ID if it is a NullProduct Good. This indicates that if the user selects it, then they don't want any product in that part.
     *
     * A NullProduct Good can never be incompatible with any other Good by our explicit decision, so we can safely ignore it being incompatible.
     */
    O.getOrElse(function () {
        return Fixtuur.Configuration.ProductSelectionsByPart.includes(productSelectionsByPart, partName, null)
            ? 'selected'
            : 'none';
    }));
};
export var sortByProductProperties = function (productCards) {
    return productCards.sort(function (a, b) {
        return Fixtuur.Good.compareProperties(a.good, b.good);
    });
};
/**
 * Constructs a record of Product Cards per Part given an array of Goods
 * For Product type Goods this will be a record with a single faux part 'adjust'
 */
export var fromGoods = function (goods, productSelectionsByPart, incompatibleGoodsIds) {
    if (incompatibleGoodsIds === void 0) { incompatibleGoodsIds = {}; }
    var productCardsByPart = Object.fromEntries(Object.entries(goods).map(function (_a) {
        var partName = _a[0], partGoods = _a[1];
        var cards = partGoods.map(function (good) {
            var _a;
            return ({
                good: good,
                status: getStatus(good, productSelectionsByPart, partName, (_a = incompatibleGoodsIds[partName]) !== null && _a !== void 0 ? _a : []),
            });
        });
        return [partName, cards];
    }));
    return productCardsByPart;
};
export var productIdFromGood = function (good) {
    return Fixtuur.Configuration.Product.is(good)
        ? Fixtuur.Configuration.Product.productId(good)
        : Fixtuur.Product.is(good)
            ? Fixtuur.Product.id(good)
            : null;
};
export function getProductDetails(good, currencyTransformationFn) {
    return pipe(O.Do, O.bind('thumbnail', function () { return Fixtuur.Good.imageForPart(good); }), O.bind('name', function () { return Fixtuur.Good.nameForPart(good); }), O.bind('price', function () { return pipe(Fixtuur.Good.price(good), O.map(currencyTransformationFn)); }), O.bind('productUrl', function () { return O.some(O.toUndefined(Fixtuur.Good.productUrl(good))); }), O.toNullable);
}
